import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Buisnesstavelscabserviceindelhi() {



  const cardData =
  {
    keyword: 'Business Travel Cab Services in Delhi',
    heading: 'Aaryan Travels: Business Travel Cab Services in Delhi',
    headingDescription: 'Aaryan Travels offers reliable Business Travel Cab Services in Delhi for corporate executives, sales teams, and professionals who require punctual and hassle-free transportation. Whether it is airport transfers from IGI Airport, hotel-to-office commutes, client visits, or intercity trips to Gurgaon, Noida, or Faridabad, our fleet of sedans, SUVs, and luxury vehicles ensures a smooth and professional travel experience. With uniformed chauffeurs, GPS-enabled cars, and flexible hourly or full-day booking options, we provide business-class mobility tailored to your schedule. From Connaught Place to Aerocity, Cyber City to Nehru Place, Aaryan Travels is your trusted partner for dependable business travel cab services across Delhi NCR.',

    top: 'Top Places to Visit in Delhi with Aaryan Travels',

"topPlaces": [
  {
    "title": "Red Fort (Lal Qila)",
    "description": "Built in 1648 by Mughal Emperor Shah Jahan, Red Fort is a UNESCO World Heritage Site known for its grand red sandstone walls and intricate Mughal architecture. It once served as the main residence of Mughal emperors. The evening light-and-sound show narrates its glorious history. Every Independence Day, the national flag is hoisted here. Red Fort is Delhi’s proud monument of heritage and freedom."
  },
  {
    "title": "India Gate",
    "description": "India Gate is a 42-meter-high war memorial built in honor of Indian soldiers who laid down their lives during World War I. The eternal flame, Amar Jawan Jyoti, burns as a tribute to their sacrifice. Surrounded by lush lawns, it is a popular spot for picnics and evening strolls. Illuminated beautifully at night, it attracts visitors across all ages. India Gate is Delhi’s patriotic landmark of honor."
  },
  {
    "title": "Qutub Minar",
    "description": "Qutub Minar, standing at 73 meters, is the tallest brick minaret in the world and a symbol of Indo-Islamic architecture. Built in 1193, its detailed carvings and Quranic inscriptions captivate visitors. The surrounding complex includes ancient mosques and the Iron Pillar that has resisted rust for centuries. Qutub Minar is Delhi’s towering jewel of history and craftsmanship."
  },
  {
    "title": "Lotus Temple",
    "description": "The Lotus Temple is a Bahá’í House of Worship shaped like a blooming lotus with 27 marble petals. Open to people of all religions, it offers silence, peace, and a space for inner reflection. Surrounded by gardens and water pools, it is a serene escape from city chaos. Lotus Temple is Delhi’s modern symbol of unity and spirituality."
  },
  {
    "title": "Humayun’s Tomb",
    "description": "Humayun’s Tomb, built in 1570, is a masterpiece of Mughal architecture and the inspiration behind the Taj Mahal. The symmetrical red sandstone structure is surrounded by lush Persian-style gardens and water channels. Its peaceful ambiance makes it ideal for walks and photography. Humayun’s Tomb is Delhi’s elegant tribute to royal legacy."
  },
  {
    "title": "Akshardham Temple",
    "description": "Akshardham Temple is a vast spiritual and cultural complex renowned for its exquisite carvings and stunning architecture. Built without steel, it features over 20,000 statues depicting deities and sages. The musical fountain show and boat ride offer unique experiences. Akshardham is Delhi’s grand celebration of devotion and tradition."
  },
  {
    "title": "Jama Masjid",
    "description": "Jama Masjid, built in 1656 by Shah Jahan, is one of India’s largest mosques. Its expansive courtyard can hold over 25,000 worshippers. The red sandstone and marble structure features domes and minarets with panoramic city views. Nearby lanes of Chandni Chowk offer Mughlai delicacies like kebabs and biryani. Jama Masjid is Delhi’s spiritual and cultural landmark."
  },
  {
    "title": "Raj Ghat",
    "description": "Raj Ghat is a black marble memorial built at the cremation site of Mahatma Gandhi. Inscribed with his last words, 'Hey Ram', it symbolizes peace and simplicity. Lush gardens and eternal flames surround the platform. World leaders often visit to pay homage. Raj Ghat is Delhi’s solemn tribute to the Father of the Nation."
  },
  {
    "title": "Hauz Khas Village",
    "description": "Hauz Khas Village offers a unique blend of medieval ruins, scenic lake views, and trendy cafes. The 14th-century Hauz Khas Fort and mosque offer picturesque settings for photography. By night, the area comes alive with music, dining, and lively culture. Hauz Khas is Delhi’s chic fusion of history and modern lifestyle."
  },
  {
    "title": "Chandni Chowk & Paranthe Wali Gali",
    "description": "Chandni Chowk is one of Delhi’s oldest and busiest markets, famous for spices, silver jewelry, and textiles. Paranthe Wali Gali is renowned for its stuffed parathas served with pickles and chutneys. Rickshaw rides through narrow lanes offer a glimpse into old Delhi charm. Chandni Chowk is Delhi’s bustling heart of flavors and tradition."
  }
],


"services": [
  {
    "name": "Business Travel Cab Services in Delhi",
    "description": "Business Travel Cab Services in Delhi provide professional and reliable transportation for corporate clients. Whether it’s for meetings, conferences, or daily commutes, our service ensures timely pickups, experienced chauffeurs, and comfortable vehicles for seamless business mobility."
  },
  {
    "name": "Delhi Business Taxi",
    "description": "Delhi Business Taxi offers dedicated transport for professionals and corporate travelers. Our fleet includes sedans, SUVs, and executive cars, all managed by trained drivers to ensure punctuality, safety, and convenience for business travel across the city."
  },
  {
    "name": "Corporate Travel Cab Delhi",
    "description": "Corporate Travel Cab Delhi caters to businesses needing consistent, high-quality transportation. From airport transfers to client meetings, our service guarantees clean vehicles, prompt service, and professional chauffeurs for all your corporate travel requirements."
  },
  {
    "name": "Executive Cab Delhi",
    "description": "Executive Cab Delhi delivers luxury and comfort for top-tier professionals and business guests. Featuring high-end vehicles and experienced drivers, this service is ideal for executive movements, VIP transfers, and corporate hospitality."
  },
  {
    "name": "Chauffeur Business Cab Delhi",
    "description": "Chauffeur Business Cab Delhi provides premium chauffeur-driven cabs for professional use. Our chauffeurs are trained in corporate etiquette, ensuring a discreet, courteous, and comfortable travel experience for executives and clients."
  },
  {
    "name": "Premium Business Taxi Delhi",
    "description": "Premium Business Taxi Delhi offers high-end vehicles and top-tier service for business professionals. Perfect for corporate events, meetings, and airport transfers, this service combines luxury with on-time performance and reliability."
  },
  {
    "name": "Affordable Business Cab Delhi",
    "description": "Affordable Business Cab Delhi delivers cost-effective transportation without compromising service quality. Ideal for startups and SMEs, our service includes clean cars, punctual drivers, and transparent pricing for business commutes and meetings."
  },
  {
    "name": "Offices Travel Cab Delhi",
    "description": "Offices Travel Cab Delhi supports daily staff commutes with dependable and scheduled cab services. We offer customizable routes, GPS tracking, and well-maintained vehicles to ensure smooth and safe office transportation."
  },
  {
    "name": "Staff Transport Delhi",
    "description": "Staff Transport Delhi provides structured cab services for employee travel. With route planning, driver tracking, and fixed schedules, this service helps companies manage large-scale staff transportation efficiently and safely."
  },
  {
    "name": "Corporate Car Rental Delhi",
    "description": "Corporate Car Rental Delhi offers long-term and short-term rental solutions for businesses. Choose from sedans, SUVs, or luxury cars with or without drivers, ideal for daily operations, client visits, and executive use."
  },
  {
    "name": "Business Event Cab Delhi",
    "description": "Business Event Cab Delhi provides specialized transportation solutions for conferences, trade shows, and corporate events. We manage logistics, coordinate large group travel, and ensure timely pickups and drops for all participants."
  },
  {
    "name": "Long Distance Business Cab Delhi",
    "description": "Long Distance Business Cab Delhi offers comfortable and reliable intercity transport for corporate travel. Whether it’s client meetings or outstation projects, our spacious vehicles and experienced drivers ensure a smooth travel experience."
  },
  {
    "name": "Business Car Hire Delhi",
    "description": "Business Car Hire Delhi offers flexible hire options for companies needing vehicles for short or extended use. Ideal for business trips, team transport, or executive travel, we offer a wide selection of cars to meet every requirement."
  },
  {
    "name": "Online Business Cab Booking Delhi",
    "description": "Online Business Cab Booking Delhi allows companies to schedule, manage, and track rides through a simple digital platform. Features include instant confirmations, billing reports, and centralized travel management for streamlined operations."
  },
  {
    "name": "Business Transport Services Delhi",
    "description": "Business Transport Services Delhi provides end-to-end cab solutions for corporate travel. From employee shuttles to VIP transfers, we offer tailored plans, professional drivers, and 24x7 support to keep your business moving efficiently."
  }
],
"tableData": [
  ["Business Travel Cab Services in Delhi", "Delhi Business Taxi"],
  ["Corporate Travel Cab Delhi", "Executive Cab Delhi"],
  ["Chauffeur Business Cab Delhi", "Premium Business Taxi Delhi"],
  ["Affordable Business Cab Delhi", "Offices Travel Cab Delhi"],
  ["Staff Transport Delhi", "Corporate Car Rental Delhi"],
  ["Business Event Cab Delhi", "Long Distance Business Cab Delhi"],
  ["Business Car Hire Delhi", "Online Business Cab Booking Delhi"],
  ["Business Transport Services Delhi", "—"]
],

"whychoose": [
  {
    "WhyChooseheading": "Business Travel Cab Services in Delhi",
    "WhyChoosedescription": "Aaryan Travels offers efficient and comfortable cab services tailored for business travel in Delhi."
  },
  {
    "WhyChooseheading": "Punctual and Professional Drivers",
    "WhyChoosedescription": "Our experienced chauffeurs ensure timely pickups and drop-offs, keeping your business schedule on track."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Vehicles",
    "WhyChoosedescription": "Travel in sanitized, air-conditioned cabs maintained for a pleasant and professional experience."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Delhi Routes",
    "WhyChoosedescription": "Our drivers know Delhi’s traffic and routes well to provide smooth and efficient rides."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy upfront pricing inclusive of all costs, ensuring hassle-free billing."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Booking Assistance",
    "WhyChoosedescription": "Our support team is available around the clock to assist with your business travel cab bookings."
  },
  {
    "WhyChooseheading": "Flexible Booking Options for One-Way or Round Trips",
    "WhyChoosedescription": "Choose rides tailored to your schedule, whether for single trips or extended business travel."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Select from sedans, SUVs, or luxury cars to suit your business travel needs."
  }
]







































  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer business travel cab services in Delhi?',
    answer: 'Yes, Aaryan Travels provides reliable and comfortable business travel cab services in Delhi tailored for corporate clients.',
  },
  {
    question: 'How can I book business travel cab services in Delhi with Aaryan Travels?',
    answer: 'You can book easily through our website, mobile app, or by contacting our 24x7 customer support team.',
  },
  {
    question: 'What types of vehicles are available for business travel cab services in Delhi?',
    answer: 'Aaryan Travels offers a range of vehicles including sedans, SUVs, and premium cars suitable for business travel.',
  },
  {
    question: 'Are drivers experienced with Delhi city routes for business travel?',
    answer: 'Absolutely. Our professional drivers are licensed and familiar with Delhi’s routes to ensure timely and smooth rides.',
  },
  {
    question: 'Can I customize pickup and drop-off locations for business travel cab bookings in Delhi?',
    answer: 'Yes, you can specify your preferred pickup and drop-off points anywhere within Delhi and nearby business hubs.',
  },
  {
    question: 'Is business travel cab service available 24x7 in Delhi?',
    answer: 'Yes, Aaryan Travels offers round-the-clock business travel cab services to accommodate your schedule.',
  },
  {
    question: 'Are safety and hygiene protocols followed for business travel cabs?',
    answer: 'All vehicles are sanitized regularly, and drivers follow strict safety and hygiene protocols for your protection.',
  },
  {
    question: 'What payment options are accepted for business travel cab services in Delhi?',
    answer: 'We accept cash, corporate accounts, digital wallets, UPI, and card payments for your convenience.',
  },
  {
    question: 'Is customer support available during business travel cab rides in Delhi?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajat Singh',
    feedback: 'Aaryan Travels made my business trips in Delhi comfortable and punctual with their excellent cab service.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Ananya Gupta',
    feedback: 'Professional and reliable business travel cab service by Aaryan Travels in Delhi. Highly recommended for corporate travelers!',
    rating: 5,
  },
];
























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];








const businessTravelCabDelhiSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Business Travel Cab Services in Delhi",
  "description": "Aaryan Travels offers reliable business travel cab services in Delhi, including executive taxis, chauffeur-driven corporate travel cabs, staff transport, and long-distance business cab hire.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Delhi"
  },
  "serviceType": "Business Travel Cab Service",
  "keywords": "Business Travel Cab Services in Delhi, Delhi Business Taxi, Corporate Travel Cab Delhi, Executive Cab Delhi, Chauffeur Business Cab Delhi, Premium Business Taxi Delhi, Affordable Business Cab Delhi, Offices Travel Cab Delhi, Staff Transport Delhi, Corporate Car Rental Delhi, Business Event Cab Delhi, Long Distance Business Cab Delhi, Business Car Hire Delhi, Online Business Cab Booking Delhi, Business Transport Services Delhi"
};







  return (
    <div>

<Helmet>
  <title>Business Travel Cab Services in Delhi | Executive & Corporate Cabs | Aaryan Travels</title>
  <meta
    name="description"
    content="Book business travel cab services in Delhi with Aaryan Travels. Executive cabs, chauffeur-driven corporate travel, staff transport, and long-distance business cab hire."
  />
  <meta
    name="keywords"
    content="Business Travel Cab Services in Delhi, Delhi Business Taxi, Corporate Travel Cab Delhi, Executive Cab Delhi, Chauffeur Business Cab Delhi, Premium Business Taxi Delhi, Affordable Business Cab Delhi, Offices Travel Cab Delhi, Staff Transport Delhi, Corporate Car Rental Delhi, Business Event Cab Delhi, Long Distance Business Cab Delhi, Business Car Hire Delhi, Online Business Cab Booking Delhi, Business Transport Services Delhi"
  />
  <script type="application/ld+json">
    {JSON.stringify(businessTravelCabDelhiSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/58.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Buisnesstavelscabserviceindelhi;